import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import ButtonLink from '../ButtonLink';
import DashboardCardHeader from '../DashboardCardHeader';

const getItemContent = (item) => {
  const itemContent = !item?.action ? (
    <ButtonLink color="primary" size="small" sx={{ pl: 0 }} to={item.link} disabled={item.disabled}>
      <Typography sx={{ textTransform: 'none' }} variant="body2">
        {item.label}
      </Typography>
    </ButtonLink>
  ) : (
    <Button color="primary" onClick={item.action} size="small" sx={{ pl: 0 }} disabled={item.disabled}>
      <Typography sx={{ textTransform: 'none' }} variant="body2">
        {item.label}
      </Typography>
    </Button>
  );
  if (item.wrapper) {
    return item.wrapper(itemContent);
  }
  return itemContent;
};

const LinksBox = ({ links, name }) => (
  <Card sx={{ height: '100%', width: '100%' }}>
    <DashboardCardHeader title={name} />
    <Box p={3} pt={2}>
      <Grid container direction="column">
        {links.map((item, id) => (
          <Grid key={`link-${id + 1}`}>{getItemContent(item)}</Grid>
        ))}
      </Grid>
    </Box>
  </Card>
);

LinksBox.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.func,
      disabled: PropTypes.bool,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      link: PropTypes.string,
      wrapper: PropTypes.func,
    })
  ).isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

export default LinksBox;
